/**
 * Configuration management for the Harmony Management UI
 * Based on the CLI configuration system but adapted for web interface
 */

export const AppMode = {
  LOCAL: "local",
  REMOTE: "remote",
} as const;

export type AppMode = (typeof AppMode)[keyof typeof AppMode];

export interface AppConfig {
  // Core mode setting
  mode: AppMode;

  // Remote mode settings
  tenantsBaseUrl: string;

  // Local mode settings
  localBaseUrl: string;
  localTenantId?: string;

  // Descope settings (for remote mode)
  descopeProjectId?: string;

  // UI theme (for future use)
  theme: string;
}

export const DEFAULT_CONFIG: AppConfig = {
  mode: AppMode.REMOTE,
  tenantsBaseUrl: `${import.meta.env.VITE_API_BASE_URL || "https://api.dev.us1.harmony.so"}/tenants`,
  localBaseUrl: "http://localhost:8000",
  localTenantId: undefined,
  descopeProjectId: import.meta.env.VITE_DESCOPE_PROJECT_ID,
  theme: "default",
};

export interface ConfigContextType {
  config: AppConfig;
  updateConfig: (updates: Partial<AppConfig>) => void;
  isLocalMode: boolean;
  needsAuth: boolean;
  getTenantsUrl: () => string;
  saveConfig: () => void;
  loadConfig: () => void;
}
